<template>
    <div class="page">
        <div class="page__bd">
            <div class="reply">
                <div class="weui-cells__title">回复用户</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__bd">
                            <textarea class="weui-textarea" v-model="content" placeholder="请输入回复的内容" rows="3"></textarea>
                            <div class="weui-textarea-counter">
                                <span>{{content.length}}</span>/256</div>
                        </div>
                    </div>
                </div>
                <div class="warehousing-footer-item" style="flex:2" @click="save">
                    <a href="javascript:;">提交回复</a>
                </div>
            </div>
        </div>

        <div class="weui-footer">
            <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
            </p>
            <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
        </div>
    </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      openid: "",
      content: "",
      year: moment().format("YYYY")
    };
  },
  created() {
    this.openid = this.$route.params.toOpenid;
    let encodeToken = this.$route.params.token;
    let token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + token;
  },
  methods: {
    save() {
      if (this.content.length < 2) {
        weui.alert("回复内容不能少于2个字");
        return;
      } else {
        axios
          .post("/api/common/answer", {
            openid: this.openid,
            content: this.content
          })
          .then(res => {
            if (res.data.success) {
              weui.toast("回复成功");
              this.content = "";
            } else {
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            weui.alert("回复失败");
          });
      }
    }
  }
};
</script>

<style scoped>
.weui-footer {
  margin-bottom: 20px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.reply {
  margin: 0px 15px 20px 15px;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/Answer.vue